export default {
  init() {
    // JavaScript to be fired on all pages

    $(".grid-wrapper").each(function () {
      // Cache the highest
      var highestBox = 0;
      // Define your media query
      var mediaQuery = window.matchMedia("(max-width: 767px)");

      // Select and loop the elements you want to equalise
      $(".column", this).each(function () {
        // If this box is higher than the cached highest then store it
        if ($(this).height() > highestBox) {
          highestBox = $(this).height();
        }
      });

      // Set the height of all those children to whichever was highest
      if (!mediaQuery.matches) {
        $(".column", this).height(highestBox);
      }
    });

    $(document).ready(function () {
      var Isotope = require("isotope-layout");

      // initialize Isotope
      var $grid = new Isotope(".grid-events", {
        itemSelector: ".element-item",
        percentPosition: true,
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });

      // filter functions
      var filterFns = {
        // show if number is greater than 50
        numberGreaterThan50: function () {
          var number = $(this).find(".number").text();
          return parseInt(number, 10) > 50;
        },
        // show if name ends with -ium
        ium: function () {
          var name = $(this).find(".name").text();
          return name.match(/ium$/);
        },
      };
      // bind filter button click
      $(".filters-button-group").on("click", "button", function () {
        var filterValue = $(this).attr("data-filter");
        // use filterFn if matches value
        filterValue = filterFns[filterValue] || filterValue;
        $grid.arrange({ filter: filterValue });
        if ($(".grid-wrapper").height() === 0) {
          // Show the message div with the specific message
          $("#message-div").removeClass("d-none");
        } else {
          // Hide the message div
          $("#message-div").addClass("d-none");
        }
      });
      // change is-checked class on buttons
      $(".button-group").each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on("click", "button", function () {
          $buttonGroup.find(".is-checked").removeClass("is-checked");
          $(this).addClass("is-checked");
        });
      });
      // bind filter on select change
      $(".filters-select").on("change", function () {
        // get filter value from option value
        var filterValue = this.value;
        // use filterFn if matches value
        filterValue = filterFns[filterValue] || filterValue;
        $grid.arrange({ filter: filterValue });
        // Check if the height of .grid-wrapper is 0px
        if ($(".grid-wrapper").height() === 0) {
          // Show the message div with the specific message
          $("#message-div").removeClass("d-none");
        } else {
          // Hide the message div
          $("#message-div").addClass("d-none");
        }
      });
    });

    $(document).ready(function () {
      $(".slick-carousel-single").slick({
        // Your options here
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<a href="#" class="slick-prev"></a>',
        nextArrow: '<a href="#" class="slick-next"></a>',
      });
    });

    $(document).ready(function () {
      $(".service-button").on("click", function () {
        handleServiceButtonClick($(this));
      });

      $(".coupon_question").click(function () {
        toggleAnswerVisibility($(this).is(":checked"));
      });

      $(".back").on("click", function () {
        handleBackButtonClick();
      });

      function handleServiceButtonClick(button) {
        var value = button.val();
        const campaignField = document.getElementById("campaign_name");
        const currentAppealField = document.getElementById("current_appeal");

        campaignField.value = value;
        currentAppealField.value = button.attr("data-current-appeal");

        var checkedid = button.attr("id");
        var numb = checkedid.match(/\d/g).join("");
        var checked = $("#checked" + numb).text();
        var label = $("#label" + numb).text();
        var vmch_connection = $("#vmch_connection" + numb).text();

        if (checked === "checked") {
          $("#additional_campaign_field").removeClass("d-none");
          if (label) {
            document.getElementById("service-category").innerHTML = label;
          } else {
            document.getElementById("service-category").innerHTML = value;
          }
        }
        
        if (vmch_connection === "checked") {
          $("#vmch_connection_field").removeClass("d-none");
        } else {
          $("#vmch_connection_field").addClass("d-none");
        }

        $(".donation_payment_form").slideToggle({ direction: "up" }, 300);
        button.attr("disabled", true);
        $(".back").addClass("d-flex");
        $(".first-para").addClass("d-none");
        button.addClass("d-flex");
        $(".service-button").addClass("d-none");
        button.removeClass("d-none");

        // Update the value of the reason2 input field
        document.getElementById("reason3").value = value;
      }

      function toggleAnswerVisibility(isChecked) {
        if (isChecked) {
          $(".answer").removeClass("d-none");
          document.getElementById("otheramount").value = "";
          $('input[name="amount"]').prop("checked", false);
        } else {
          $(".answer").addClass("d-none");
        }
      }

      function handleBackButtonClick() {
        $(".donation_payment_form").slideToggle({ direction: "down" }, 300);
        $(".back").removeClass("d-flex");
        $(".service-button").attr("disabled", false);
        $(".first-para").removeClass("d-none");
        $(".service-button").removeClass("d-flex d-none");
        $("#additional_campaign_field").addClass("d-none");
        document.getElementById("service-category").innerHTML = "";
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js